import { Link } from "react-router-dom";
import { Shield, Lock, FileCheck } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_med-transcribe-4/artifacts/hi10en9r_ChatGPT%20Image%20Feb%208%2C%202026%2C%2008_43_59%20PM.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#050505] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-10 sm:py-16">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand Column */}
          <div className="sm:col-span-2">
            <Link to="/" className="inline-block mb-4 sm:mb-6">
              <img 
                src={LOGO_URL} 
                alt="MedinoteX Logo" 
                className="h-8 sm:h-10 w-auto"
              />
            </Link>
            <p className="text-slate-400 mb-4 sm:mb-6 max-w-sm text-sm sm:text-base">
              Document Less. Care More. Professional medical documentation services for healthcare providers.
            </p>
            <div className="flex flex-wrap gap-2 sm:gap-3">
              <div className="flex items-center gap-1.5 sm:gap-2 text-[10px] sm:text-xs text-slate-500">
                <Shield className="w-3 h-3 sm:w-4 sm:h-4 text-cyan-500" />
                HIPAA Compliant
              </div>
              <div className="flex items-center gap-1.5 sm:gap-2 text-[10px] sm:text-xs text-slate-500">
                <Lock className="w-3 h-3 sm:w-4 sm:h-4 text-cyan-500" />
                256-bit Encryption
              </div>
              <div className="flex items-center gap-1.5 sm:gap-2 text-[10px] sm:text-xs text-slate-500">
                <FileCheck className="w-3 h-3 sm:w-4 sm:h-4 text-cyan-500" />
                SOC 2 Type II
              </div>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Services</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <span className="text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer text-xs sm:text-sm">
                  Real-Time Scribing
                </span>
              </li>
              <li>
                <span className="text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer text-xs sm:text-sm">
                  AI-Enhanced Editing
                </span>
              </li>
              <li>
                <span className="text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer text-xs sm:text-sm">
                  HIPAA Transcription
                </span>
              </li>
              <li>
                <span className="text-slate-400 hover:text-cyan-400 transition-colors cursor-pointer text-xs sm:text-sm">
                  Quality Review
                </span>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-white font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Contact</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link 
                  to="/contact" 
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-xs sm:text-sm"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  state={{ requestDemo: true }}
                  className="text-slate-400 hover:text-cyan-400 transition-colors text-xs sm:text-sm"
                >
                  Schedule Demo
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-xs sm:text-sm">
              © {currentYear} MedinoteX. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
              <span className="text-slate-500 hover:text-slate-400 transition-colors text-xs sm:text-sm cursor-pointer">
                Privacy Policy
              </span>
              <span className="text-slate-500 hover:text-slate-400 transition-colors text-xs sm:text-sm cursor-pointer">
                Terms of Service
              </span>
              <span className="text-slate-500 hover:text-slate-400 transition-colors text-xs sm:text-sm cursor-pointer">
                HIPAA Notice
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
